/**
 * mapAsUrlsAndDomains takes an array of URL strings and returns an array of objects
 * with the URL and its domain
 * @param {Array.<string>} urls - array of URL strings
 * @returns array of objects, each containing a url and domain
 */
export function mapAsUrlsAndDomains(urls) {
  const output = [];
  for (const url of urls) {
    try {
      const hostname = new URL(url).hostname;
      const domain = hostname.replace(/^www\./, '');
      output.push({ url, domain });
    } catch {
      // invalid URL; don't add to output
    }
  }
  return output;
}
